export const BLURB_PREVIEW_LANGUAGE_SELECTED = 'BLURB_PREVIEW_LANGUAGE_SELECTED';

export function selectBlurbPreviewLanguage(blurbPreviewLanguage) {
  return {
    type: BLURB_PREVIEW_LANGUAGE_SELECTED,
    blurbPreviewLanguage,
  };
}
